document.addEventListener('DOMContentLoaded', () => {
  const swatches = document.querySelectorAll('.collection-tab__swatch');
  const tabs = document.querySelectorAll('.collection-tab');
  const selectedColorEl = document.querySelector('[data-selected-color]');

  if (!swatches.length || !tabs.length || !selectedColorEl) return;

  const formatLabel = (key) =>
    key
      .split('-')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ');

  swatches.forEach((swatch) => {
    const key = swatch.dataset.swatch;

    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');

      tabs.forEach(tab => {
        tab.classList.toggle(
          'hidden',
          tab.dataset.collectionTab !== key
        );
      });

      selectedColorEl.textContent = formatLabel(key);
    });

    swatch.addEventListener('mouseenter', () => {
      selectedColorEl.textContent = formatLabel(key);
    });

    swatch.addEventListener('mouseleave', () => {
      const active = document.querySelector(
        '.collection-tab__swatch.selected'
      );
      if (active) {
        selectedColorEl.textContent = formatLabel(active.dataset.swatch);
      }
    });
  });
});